export const goToExternalLink = (url: string, protocol: string = '') => {
  const isProtocolIncluded = protocol ? url.includes(protocol) : false;
  const newWindow = window.open(isProtocolIncluded ? url : `${protocol}${url}`, '_blank');
  if (newWindow) {
    newWindow.focus();
  }
};
